//Custom components
import StatCard from '../../../UI/Card/StatCard';
import { CurrencyFormatDisplay } from '../../../UI/NumberFormatDisplay/CurrencyFormatDisplay';

const DevelopersInvestmentWidget = ({ count }: { count: number | string }) => {
  return <StatCard title='Developers Investment' stat={<CurrencyFormatDisplay value={count} prefix='$' />} />;
};

export default DevelopersInvestmentWidget;
